import { render, staticRenderFns } from "./SampleGadgetBaseV3.vue?vue&type=template&id=b9ea6212&scoped=true&"
import script from "./SampleGadgetBaseV3.vue?vue&type=script&lang=ts&"
export * from "./SampleGadgetBaseV3.vue?vue&type=script&lang=ts&"
import style0 from "./SampleGadgetBaseV3.vue?vue&type=style&index=0&id=b9ea6212&lang=scss&scoped=true&"
import style1 from "./SampleGadgetBaseV3.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9ea6212",
  null
  
)

export default component.exports